// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

// import styles bundle
import 'swiper/css/bundle';

export default function swiper(target) {
  if (!target) {
    return
  }

  switch (target) {
    case '.swiper-custom-0':
      return new Swiper(target, {
        a11y: true,
        allowTouchMove: true,
        keyboard: {
          enabled: true,
          onlyInViewport: false,
        },
        setEqualHeight: true,
        autoplay: true,
        speed: 1500,
        effect: "fade",
        height: '100%',
        fadeEffect: {
          crossFade: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          type: 'bullets',
        },
      });
      break;
    // default takes .swiper
    default:
      return new Swiper(target, {
        a11y: true,
        speed: 400,
        slidesPerView: '1.2',
        setEqualHeight: true,
        spaceBetween: 16,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          640: {
            slidesPerView: 'auto',
            spaceBetween: 24,
          },
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      } );
  }
}

